module.exports = __webpack_public_path__ + "img/sample03-02.86bd5b46.png";